// frontend/src/utils/minimumStockColDef.js
//
// Shared column-def builder for the Minimum stock cell, used by the Inventory
// grid and the Item Setup grid. Both render `min_inventory_units` — the lowest
// stock the merchant wants to keep of an item at a location
// (backend ItemLocation.MinInventoryUnits).
//
// Never dimmed: every inventory target mode reads it
// (backend/purchase_orders_engine/inventory_target.py), unlike the Safety
// stock and Days of supply cells, each of which one mode leaves inert.

import { parseBlankIsZeroUnitsCell } from './planningCellParsers';

/**
 * @param {object} opts
 * @param {(key: string) => string} opts.t  i18n lookup.
 * @param {(raw: string) => number} opts.parseNumber  the page's LOCALE-AWARE
 *   parser (useFormatters), not the global `Number`.
 * @param {boolean | ((params: object) => boolean)} [opts.editable=true]
 * @returns {object} Partial column def; the caller adds width/pinning/etc.
 */
export function minimumStockColDef({ t, parseNumber, editable = true }) {
  if (typeof parseNumber !== 'function') {
    throw new Error('minimumStockColDef: parseNumber is required');
  }

  return {
    field: 'min_inventory_units',
    headerName: t('inventory.columns.minimumStock'),
    headerTooltip: t('inventory.tooltips.minimumStock'),
    editable,
    type: 'numberColumn',
    valueParser: (params) => parseBlankIsZeroUnitsCell(params, parseNumber),
  };
}
